"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserBuffer = require('buffer/').Buffer;
exports.BufferClass = typeof process !== 'undefined' && typeof process.exit === 'function' ? Buffer : BrowserBuffer;
//# sourceMappingURL=buffer.js.map